// Shop-Seite: Filter, Sortierung, Ansichtswechsel, Produktvergleich.
//
// Diese Blöcke fehlten nach dem ersten Theme-Umbau: Übernommen wurde nur das
// gemeinsame JavaScript (Menü, Warenkorb, Suche), das Seitenspezifische nicht.

// ---- Sorting grid background animation (tiles re-shuffle to new positions) ----
  (function initSortGrid() {
    var container = document.getElementById('sortGridBg');
    if (!container) return;

    var tileCount = 14;
    var tiles = [];

    function randomPos() {
      return {
        top: Math.random() * 82 + '%',
        left: Math.random() * 92 + '%'
      };
    }

    for (var i = 0; i < tileCount; i++) {
      var tile = document.createElement('div');
      tile.className = 'sort-tile' + (i % 3 === 0 ? ' alt' : '');
      var pos = randomPos();
      tile.style.top = pos.top;
      tile.style.left = pos.left;
      container.appendChild(tile);
      tiles.push(tile);
    }

    function reshuffle() {
      tiles.forEach(function (tile, index) {
        // stagger the reshuffle slightly per tile for a more organic wave feel
        setTimeout(function () {
          var pos = randomPos();
          tile.style.top = pos.top;
          tile.style.left = pos.left;
        }, index * 60);
      });
    }

    setInterval(reshuffle, 3200);
  })();

// ---- Paginierung entfernt: Sie war ein Entwurfs-Relikt gegen nicht
// existente IDs (#shopPagination/#pageNumbers) — die echte Paginierung
// rendert Shopify serverseitig (sections/shop.liquid).

// ---- Price range dual-handle slider ----
  (function initPriceSlider() {
    var slider = document.getElementById('priceSlider');
    var handleMin = document.getElementById('priceHandleMin');
    var handleMax = document.getElementById('priceHandleMax');
    var fill = document.getElementById('priceSliderFill');
    var inputMin = document.getElementById('priceMinInput');
    var inputMax = document.getElementById('priceMaxInput');
    if (!slider || !handleMin || !handleMax) return;

    // War: minLimit 0 / maxLimit 2000 fest im Code. Bei Kollektionen mit
    // teureren Produkten (Grafikkarten über 1.600 €) waren die oberen
    // Preisklassen damit gar nicht erreichbar. Die Grenzen kommen jetzt
    // aus der Kollektion selbst (siehe data-min/data-max im Liquid).
    var minLimit = parseInt(slider.getAttribute('data-min'), 10);
    var maxLimit = parseInt(slider.getAttribute('data-max'), 10);
    // Kein-Limit-Modus (02.10.2026): Liquid deckelt den Regler bei
    // 20.000 Euro, wenn die Kollektion teurere Artikel enthaelt. Der
    // Anschlag ganz rechts bedeutet dann "Kein Limit" - es wird kein
    // Hoechstpreis-Filter gesetzt (passiert unten von selbst, weil bei
    // maxValue == maxLimit kein lte-Parameter geschrieben wird).
    var keinLimit = slider.getAttribute('data-kein-limit') === '1';
    if (isNaN(minLimit)) minLimit = 0;
    if (isNaN(maxLimit) || maxLimit <= minLimit) maxLimit = minLimit + 1000;

    var spanne = maxLimit - minLimit;
    var step = spanne > 5000 ? 50 : (spanne > 1000 ? 10 : 1);
    var minGapPercent = 4; // smallest allowed distance between the two handles, in %

    // NEU (03.09.2026): Mit aktiver Auswahl starten, nicht mit der
    // Gesamtspanne — sonst springt der Regler nach "Preis übernehmen"
    // beim Neuladen optisch auf Anfang (Halils Befund).
    var minValue = parseInt(slider.getAttribute('data-aktiv-min'), 10);
    var maxValue = parseInt(slider.getAttribute('data-aktiv-max'), 10);
    if (isNaN(minValue) || minValue < minLimit || minValue > maxLimit) minValue = minLimit;
    if (isNaN(maxValue) || maxValue > maxLimit || maxValue < minValue) maxValue = maxLimit;

    function valueToPercent(value) {
      return ((value - minLimit) / (maxLimit - minLimit)) * 100;
    }

    function percentToValue(percent) {
      var raw = minLimit + (percent / 100) * (maxLimit - minLimit);
      return Math.round(raw / step) * step;
    }

    var blaseMin = document.getElementById('priceBlaseMin');
    var blaseMax = document.getElementById('priceBlaseMax');

    function render() {
      var minPercent = valueToPercent(minValue);
      var maxPercent = valueToPercent(maxValue);

      handleMin.style.left = minPercent + '%';
      handleMax.style.left = maxPercent + '%';
      fill.style.left = minPercent + '%';
      fill.style.right = (100 - maxPercent) + '%';

      // Felder sind jetzt tippbare Zahlenfelder (das € steht daneben im
      // Markup) — beim Tippen nicht unter den Fingern überschreiben.
      if (inputMin && document.activeElement !== inputMin) inputMin.value = minValue;
      if (inputMax && document.activeElement !== inputMax) {
        if (keinLimit && maxValue >= maxLimit) {
          inputMax.value = '';
          inputMax.placeholder = 'Kein Limit';
        } else {
          inputMax.value = maxValue;
        }
      }
      if (blaseMin) blaseMin.textContent = minValue + ' €';
      if (blaseMax) blaseMax.textContent = (keinLimit && maxValue >= maxLimit) ? 'Kein Limit' : (maxValue + ' €');
    }

    // Tippen im Zahlenfeld bewegt den Regler mit — 500 eintippen geht
    // schneller als zielen. Übernommen wird beim Verlassen/Enter.
    function feldAnbinden(feld, typ) {
      if (!feld) return;
      function uebernehmen() {
        var wert = parseInt(feld.value, 10);
        if (isNaN(wert)) {
          // Leeres Hoechstpreis-Feld im Kein-Limit-Modus = Anschlag rechts
          if (typ === 'max' && keinLimit) maxValue = maxLimit;
          render();
          return;
        }
        wert = Math.max(minLimit, Math.min(maxLimit, wert));
        if (typ === 'min') minValue = Math.min(wert, maxValue - step);
        else maxValue = Math.max(wert, minValue + step);
        render();
      }
      feld.addEventListener('change', uebernehmen);
      feld.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { uebernehmen(); feld.blur(); }
      });
    }
    feldAnbinden(inputMin, 'min');
    feldAnbinden(inputMax, 'max');

    function clampAndSet(handleType, percent) {
      percent = Math.max(0, Math.min(100, percent));
      var value = percentToValue(percent);

      if (handleType === 'min') {
        var maxAllowed = valueToPercent(maxValue) - minGapPercent;
        var clampedPercent = Math.min(percent, maxAllowed);
        minValue = Math.max(minLimit, percentToValue(clampedPercent));
        if (minValue > maxValue - step) minValue = maxValue - step;
      } else {
        var minAllowed = valueToPercent(minValue) + minGapPercent;
        var clampedPercent = Math.max(percent, minAllowed);
        maxValue = Math.min(maxLimit, percentToValue(clampedPercent));
        if (maxValue < minValue + step) maxValue = minValue + step;
      }

      render();
    }

    function startDrag(handleEl, handleType) {
      function getPercentFromEvent(e) {
        var rect = slider.getBoundingClientRect();
        var clientX = e.touches ? e.touches[0].clientX : e.clientX;
        var percent = ((clientX - rect.left) / rect.width) * 100;
        return percent;
      }

      function onMove(e) {
        e.preventDefault();
        clampAndSet(handleType, getPercentFromEvent(e));
      }

      function onEnd() {
        document.removeEventListener('mousemove', onMove);
        document.removeEventListener('mouseup', onEnd);
        document.removeEventListener('touchmove', onMove);
        document.removeEventListener('touchend', onEnd);
      }

      document.addEventListener('mousemove', onMove);
      document.addEventListener('mouseup', onEnd);
      document.addEventListener('touchmove', onMove, { passive: false });
      document.addEventListener('touchend', onEnd);
    }

    handleMin.addEventListener('mousedown', function (e) { e.preventDefault(); startDrag(handleMin, 'min'); });
    handleMax.addEventListener('mousedown', function (e) { e.preventDefault(); startDrag(handleMax, 'max'); });
    handleMin.addEventListener('touchstart', function () { startDrag(handleMin, 'min'); });
    handleMax.addEventListener('touchstart', function () { startDrag(handleMax, 'max'); });

    // Keyboard support for accessibility (arrow keys nudge the focused handle)
    function onKeydown(handleType) {
      return function (e) {
        var currentPercent = handleType === 'min' ? valueToPercent(minValue) : valueToPercent(maxValue);
        var nudge = (maxLimit - minLimit > 0) ? (step / (maxLimit - minLimit)) * 100 : 1;
        if (e.key === 'ArrowRight' || e.key === 'ArrowUp') {
          clampAndSet(handleType, currentPercent + nudge);
          e.preventDefault();
        } else if (e.key === 'ArrowLeft' || e.key === 'ArrowDown') {
          clampAndSet(handleType, currentPercent - nudge);
          e.preventDefault();
        }
      };
    }
    handleMin.addEventListener('keydown', onKeydown('min'));
    handleMax.addEventListener('keydown', onKeydown('max'));

    // Der Knopf übergibt die Auswahl an Shopifys Preisfilter — und erhält
    // dabei ALLE übrigen Parameter (Marke, Verfügbarkeit, Sortierung).
    // Vorher überlebte nur sort_by: Wer erst die Marke wählte und dann
    // den Preis setzte, verlor die Marke. Nur page fliegt raus — nach
    // einer Preisänderung soll es auf Seite 1 zurückgehen.
    var anwendenBtn = document.getElementById('preisAnwenden');
    if (anwendenBtn) {
      anwendenBtn.addEventListener('click', function () {
        var pfad = slider.getAttribute('data-pfad') || window.location.pathname;
        var params;
        try { params = new URLSearchParams(window.location.search); }
        catch (e) { params = new URLSearchParams(); }
        params.delete('filter.v.price.gte');
        params.delete('filter.v.price.lte');
        params.delete('page');
        if (minValue > minLimit) params.set('filter.v.price.gte', minValue);
        if (maxValue < maxLimit) params.set('filter.v.price.lte', maxValue);
        var q = params.toString();
        window.location.href = pfad + (q ? '?' + q : '');
      });
    }

    render();
  })();

// ---- Filter chips: toggle active state on click ----
  // Gilt nur für die Marken-Filter (echte <button>-Elemente). Die
  // Kategorie-Chips sind jetzt <a>-Links zu den Kollektionen — ein Klick
  // soll dort ganz normal zur Zielseite führen, nicht nur eine Klasse
  // umschalten, während man auf der Stelle stehen bleibt.
  (function initFilterChips() {
    var chips = document.querySelectorAll('button.filter-chip');
    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        chip.classList.toggle('is-active');
      });
    });
  })();

// ---- Shop: custom sort dropdown ----
  (function initSortDropdown() {
    var trigger = document.getElementById('sortTrigger');
    var panel = document.getElementById('sortPanel');
    var label = document.getElementById('sortTriggerLabel');
    if (!trigger || !panel || !label) return;

    function openPanel() {
      panel.classList.add('is-open');
      trigger.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
    }

    function closePanel() {
      panel.classList.remove('is-open');
      trigger.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
    }

    trigger.addEventListener('click', function (e) {
      e.stopPropagation();
      if (panel.classList.contains('is-open')) {
        closePanel();
      } else {
        openPanel();
      }
    });

    // War: der Klick tauschte nur die Beschriftung aus und schloss das
    // Panel — sortiert wurde nie. Die Einträge sind jetzt echte Links auf
    // ?sort_by=... (siehe sections/shop.liquid); Shopify sortiert dann
    // serverseitig den gesamten Katalog. Hier bleibt nur das Schließen
    // beim Klick daneben und mit Escape.
    document.addEventListener('click', function (e) {
      if (!trigger.contains(e.target) && !panel.contains(e.target)) closePanel();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closePanel();
    });


    // Cookie-Banner- und Passwort-vergessen-Duplikate entfernt:
    // Der Cookie-Banner wird bereits zentral in nexus-base.js verdrahtet
    // (hier liefen die Klick-Handler doppelt), und die Passwort-vergessen-
    // Logik war eine alte Attrappe — der Shop ist passwortlos.
  })();

// ---- Shop: view toggle (grid vs list) ----
  (function initViewToggle() {
    var gridBtn = document.getElementById('viewGrid');
    var listBtn = document.getElementById('viewList');
    var grid = document.getElementById('shopGrid');
    if (!gridBtn || !listBtn || !grid) return;

    gridBtn.addEventListener('click', function () {
      grid.classList.remove('is-list-view');
      gridBtn.classList.add('is-active');
      listBtn.classList.remove('is-active');
    });

    listBtn.addEventListener('click', function () {
      grid.classList.add('is-list-view');
      listBtn.classList.add('is-active');
      gridBtn.classList.remove('is-active');
    });
  })();

// ---- Produktvergleich entfernt: Die Vergleichsleiste (#compareBar)
// existierte nie im Markup, die Daten waren Demo-Platzhalter (iPhone,
// PlayStation). Knopf und Modal sind aus dem Markup entfernt; wenn der
// Vergleich kommen soll, wird er als echtes Feature neu gebaut.


// ---- Filter und Sortierung zusammenführen ----
// Die Links kommen serverseitig ohne Wissen um die jeweils andere Auswahl:
// Ein Sortier-Link würde aktive Filter verwerfen, ein Filter-Link die
// Sortierung. Hier werden die hrefs beim Laden um die aktuellen
// Query-Parameter ergänzt (page wird bewusst verworfen — nach einer
// Änderung soll es auf Seite 1 zurückgehen).
  (function filterSortierungVerbinden() {
    var aktuelle;
    try { aktuelle = new URLSearchParams(window.location.search); }
    catch (e) { return; }

    // Sortier-Links: alle aktiven filter.*-Parameter anhängen.
    document.querySelectorAll('.sort-panel a.sort-option').forEach(function (link) {
      try {
        var url = new URL(link.getAttribute('href'), window.location.origin);
        if (url.origin !== window.location.origin) return;
        aktuelle.forEach(function (wert, name) {
          if (name.indexOf('filter.') === 0) url.searchParams.append(name, wert);
        });
        link.setAttribute('href', url.pathname + '?' + url.searchParams.toString());
      } catch (e) { /* Link unverändert lassen */ }
    });

    // Filter-Links in der Seitenleiste (Verfügbarkeit, Marke, Kategorie)
    // und aktive-Filter-Chips: sort_by beibehalten.
    var sortierung = aktuelle.get('sort_by');
    if (sortierung) {
      var selektoren = '.filter-sidebar a.filter-chip, .filter-sidebar a.fl2-opt, .fl2-auswahl a, .shop-aktive-filter a';
      document.querySelectorAll(selektoren).forEach(function (link) {
        try {
          var url = new URL(link.getAttribute('href'), window.location.origin);
          if (url.origin !== window.location.origin) return;
          if (!url.searchParams.has('sort_by')) url.searchParams.set('sort_by', sortierung);
          var q = url.searchParams.toString();
          link.setAttribute('href', url.pathname + (q ? '?' + q : ''));
        } catch (e) { /* Link unverändert lassen */ }
      });
    }
  })();

// ---- Filtergruppen ein- und ausklappen ----
// Bei Kollektionen mit vielen Marken wird die Leiste sehr lang. Ein Klick
// auf die Gruppenüberschrift klappt sie zu. Die Auswahl bleibt über
// sessionStorage erhalten, damit sie beim Blättern nicht zurückspringt.
  (function filterGruppenInit() {
    var gruppen = document.querySelectorAll('.filter-group[data-gruppe]');
    if (!gruppen.length) return;

    gruppen.forEach(function (gruppe) {
      var kopf = gruppe.querySelector('.filter-group-kopf');
      if (!kopf) return;
      var name = gruppe.getAttribute('data-gruppe');

      // Gemerkten Zustand wiederherstellen.
      try {
        if (sessionStorage.getItem('nx-filter-zu-' + name) === '1') {
          gruppe.classList.add('is-zu');
        }
      } catch (e) { /* privater Modus: dann eben ohne Gedächtnis */ }

      kopf.addEventListener('click', function () {
        gruppe.classList.toggle('is-zu');
        try {
          sessionStorage.setItem('nx-filter-zu-' + name, gruppe.classList.contains('is-zu') ? '1' : '0');
        } catch (e) { /* egal */ }
      });
    });
  })();

// ---- Filterleiste auf dem Handy öffnen/schließen ----
  (function filterMobilInit() {
    var knopf = document.getElementById('shopFilterMobil');
    var leiste = document.getElementById('shopFilterLeiste');
    var zu = document.getElementById('shopFilterSchliessen');
    if (!knopf || !leiste) return;

    function oeffnen() {
      leiste.classList.add('is-offen');
      document.body.style.overflow = 'hidden';
    }
    function schliessen() {
      leiste.classList.remove('is-offen');
      document.body.style.overflow = '';
    }

    knopf.addEventListener('click', oeffnen);
    if (zu) zu.addEventListener('click', schliessen);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') schliessen();
    });
  })();
